import { useRouter } from 'next/router';
import { ClaimFlowType } from 'types';

type useTransactionTypeApi = {
  transactionTypeText: string;
  claimType: ClaimFlowType;
};

function useTransactionType(): useTransactionTypeApi {
  const router = useRouter();
  const requestFlow = {
    transactionTypeText: 'request',
    claimType: ClaimFlowType.receive,
  };
  const payFlow = {
    transactionTypeText: 'payment',
    claimType: ClaimFlowType.pay,
  };

  const transactionType = router.route.includes('request')
    ? requestFlow
    : payFlow;

  return transactionType;
}

export default useTransactionType;
